import Vue from 'vue';
import Router from 'vue-router';
import Play from '@/components/play';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:gameId/:pinCode?',
      name: 'playGame',
      component: Play,
      props: true
    },
    {
      path: '/',
      beforeEnter: () => {
        window.location.href = process.env.VUE_APP_DSMTW_WEBSITE;
      }
    }
  ]
});
